export class TdoMdiBoundsModel {
  static HARD_RESET_TYPE = 'hard';
  static SOFT_RESET_TYPE = 'soft';

  width: number;
  height: number;
  left: number = 0;
  top: number = 0;
}
